<template>
  <div id="app">
    <loading :active.sync="$store.state.configuracoes.loading"
      :can-cancel="false"
      :is-full-page="true"
      :container="null"
      color="#F85E28"
      loader="spinner"
      :width="100"
      :height="100"
      backgroundColor="#ffffff"
      :opacity="0.5"
      :zIndex="999"
      >
      </loading>
    <Header />
    <main id="page-wrap">
        <transition mode="out-in">
          <router-view :key="$route.fullPath"/>
        </transition>
    </main>
    <div v-if="$store.state.menu.finalizacaoPedido == true && $vssWidth > 1000">
    <div v-if="aberto && $vssWidth > 1000">
    <Slide @:burgerIcon="false" :crossIcon="false" disableOutsideClick disableEsc isOpen width="350" noOverlay :right="true">
      <Carrinho />
    </Slide>
    </div>
    </div>
    <div v-else-if="$store.state.menu.finalizacaoPedido == true && $vssWidth < 1001 ">
    <div v-if="fecharCarrinho">
    <Slide @:burgerIcon="false" :crossIcon="false" isOpen width="350" noOverlay :right="true">
      <Carrinho />
    </Slide>
    </div>
    </div>
    <div v-else>
    <div v-if="aberto">
    <Slide @closeMenu="handleCloseMenu" @:burgerIcon="false" :crossIcon="false" :isOpen="aberto" width="350" noOverlay :right="true">
      <Carrinho />
    </Slide>
    </div>
    </div>
    <div v-if="$vssWidth < 1001 && $store.state.menu.finalizacaoPedido == true">
      <CarrinhoFooter />
    </div>
    <Footer />
    <div v-if="aberto && $store.state.menu.finalizacaoPedido == false && $vssWidth > 1000" class="overlay1"></div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { Slide } from 'vue-burger-menu'
import Carrinho from './views/Carrinho'
import CarrinhoFooter from './views/CarrinhoFooter'
import { mapGetters, mapActions } from 'vuex'
import { db } from '@/firebase.js'
import VueScreenSize from 'vue-screen-size'
import Loading from 'vue-loading-overlay'

export default {
  name: 'App',
  mixins: [VueScreenSize.VueScreenSizeMixin],
  components: {
    Header,
    Footer,
    Slide,
    Carrinho,
    CarrinhoFooter,
    Loading
  },
  created () {
    document.title = 'Promoções - Ilha do Caranguejo'
    window.addEventListener('beforeunload', this.removerReload)
    this.runPixelCode();
    this.getUsuario()
    this.getCarrinho()
  },
  methods: {
    ...mapActions('menu', ['toggleMenu']),
    ...mapActions('usuario', ['usuarioAtual']),
    ...mapActions('carrinho', ['limparCarrinho']),
    runPixelCode () {
      !function(f,b,e,v,n,t,s) {
        if(f.fbq)return;n=f.fbq=function(){
          n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)
        };
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];
        t=b.createElement(e);
        t.async=!0;
        t.src=v;
        s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(
          window, document,'script', 'https://connect.facebook.net/en_US/fbevents.js'
        );
        fbq('init', '349821907534822');
        fbq('track', 'PageView');
        fbq('track', 'ViewContent');
        fbq('track', 'AddToCart')
        fbq('track', 'AddPaymentInfo');
        fbq('track', 'Purchase', {value: 0.00, currency: 'USD'});
    },
    getCarrinho () {
      db.collection('Carrinho').onSnapshot((snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === 'removed') {
            if (change.doc.id === this.$store.state.carrinho.idCarrinho && this.$store.state.carrinho.pagamentoConcluido === false) {
              this.$alert('O prazo para conclusão da sua compra expirou')
              this.limparCarrinho()
              this.toggleMenu(false)
              this.$router.push({name: 'HomePage'})
            }
          }
        })
      })
    },
    getUsuario () {
      this.usuarioAtual(JSON.parse(localStorage.getItem('usuarioAtual')))
    },
    async removerReload (event) {
      for (var i in this.$store.state.carrinho.produtos) {
        await db.collection('Promocoes').doc(this.$store.state.carrinho.produtos[i].id.replace(this.$store.state.carrinho.produtos[i].unidade, '')).get().then((doc) => {
          var mapa = doc.data().QtdUnidadesReserva
          mapa[this.$store.state.carrinho.produtos[i].unidade] = doc.data().QtdUnidadesReserva[this.$store.state.carrinho.produtos[i].unidade] - this.$store.state.carrinho.produtos[i].quantidade
          db.collection('Promocoes').doc(this.$store.state.carrinho.produtos[i].id.replace(this.$store.state.carrinho.produtos[i].unidade, '')).update({
            'QtdUnidadesReserva': mapa
          })
        })
      }
    },
    handleCloseMenu () {
      this.toggleMenu(false)
    }
  },
  computed: {
    ...mapGetters('menu', {
      aberto: 'sidebarOpen'
    }),
    fecharCarrinho () {
      if (this.$vssWidth < 1001) {
        return false
      } else {
        return this.aberto
      }
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

body,
h1,
h2,
h3,
h4,
h5,
h6,
p,
ul,
li,
a,
img,
input {
  margin: 0px;
  padding: 0px;
}

.fas fa-shopping-cart {
  position: absolute;
  width: 36px;
  height: 30px;
  left: 36px;
  top: 53px;
  opacity: 0.0;
}

body {
  font-family: "Montserrat", Open Sans, Helvetica, Arial, sans-serif;
  color: #222222;
  background: #F3F3F3;
}

ul {
  list-style: none;
}

a {
  text-decoration: none;
  cursor: pointer;
}

a:hover {
  color: #333;
}

img {
  display: block;
  max-width: 100%;
}

* {
  box-sizing: border-box;
}

.bold {
  font-weight: 600;
}

.preco-cardapio {
  text-decoration: line-through;
}

#app {
  font-family: "Montserrat", Open Sans, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
}

#main {
  flex: 1;
  padding: 0;
  margin: 0 auto;
  width: 100%;
}

section {
  max-width: 1174px;
  margin: 0 auto;
}

/* EFEITO DE TRANSIÇÃO */
.v-enter,
.v-leave-to {
  opacity: 0;
}

.v-enter {
  transform: translate3d(0, -20px, 0);
}

.v-leave-to {
  transform: translate3d(0, 20px, 0);
}

.v-enter-active {
  /* .v-leave-active {*/
  transition: all 0.5s;
}
/* ------------------------------ */

input,
textarea,
select {
  border-radius: 4px;
  border: 1px solid white;
  padding: 10px;
  box-shadow: 0 4px 8px rgba(30, 60, 90, 0.1);
  transition: all 0.3s;
  font-size: 1rem;
  font-family: "Montserrat", Open Sans, Helvetica, Arial, sans-serif;
  margin: 5px 0;
  width: 90%;
  color: #2E9189;
  background: #f3f3f3;
}

.btn {
  display: block;
  padding: 14px 50px;
  background: #F85E28;
  border-radius: 4px;
  color: #fff;
  text-align: center;
  font-size: 1rem;
  box-shadow: 0 4px 8px rgba(30, 60, 90, 0.2);
  transition: all 0.3s;
  border: none;
  cursor: pointer;
}

.btn:hover {
  background: #E1331B;
  transform: scale(1.1);
}

.btn-disabled {
  background: #bbc;
  border-radius: 4px;
  display: block;
  padding: 14px 50px;
  font-size: 1rem;
  box-shadow: 0 4px 8px rgba(30, 60, 90, 0.2);
  transition: all 0.3s;
  border: none;
  cursor: pointer;
}

.btn-disabled:hover {
  background: #bbc;
  transform: scale(1.1);
}

.bm-burger-button {
  position: absolute;
  width: 36px;
  height: 30px;
  left: 36px;
  top: 53px;
  opacity: 0.0;
}

.right .bm-burger-button {
  left: initial;
  right: 36px;
}
.bm-burger-bars {
  background: #0ff;
}

.bm-morph-shape {
  fill: #ff0;
}

.bm-overlay {
  background: #F3F3F3;
}

.bm-menu {
  background: #FFFFFF !important;
  z-index: 1000;
}

.overlay1 {
  width: 100%;
  height: 100%;
  z-index: 998;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  transition: all 0.3s;
}

/* Configurações do LOGIN  e MINHA CONTA */
/* etapas */
.etapas {
  grid-area: etapas;
  display: flex;
  justify-content: center;
}

.etapas-titulo {
  grid-area: etapas-titulo;
  display: flex;
  justify-content: center;
  margin-top: -10px;
}

.etapas-titulo p {
  font-size: 0.8em;
  display: block;
  width: 120px;
}

.p-ativo {
  color: #2E9189;
}

.p-inativo {
  color: #999;
}

.linha-espaco {
  width: 80px;
  height: 1px;
  align-self: center;
  margin: 0 10px;
}

.etapas input {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  float: left;
  margin: 5px;
  transition: 0.3s ease;
  cursor: pointer;
}

.btn-ativo {
  background: #2E9189;
  color: #fff;
}

.btn-ativo:hover {
  background: #145B56;
  color: #fff;
}

.btn-inativo{
  background: #f3f3f3;
  color: #666;
}

.btn-inativo:hover {
  background: #CCFCEE;
}

.linha {
  width: 150px;
  height: 1px;
  background: #7BD1B8;
  align-self: center;
  margin: 0 10px;
}

@media (max-width: 960px) {
  .etapas {
    display: none;
  }
  .etapas input {
    width: 30px;
    height: 30px;
    padding-top: 5px;
  }
  .etapas-titulo {
    justify-content: center;
    margin-top: 0;
  }
  .etapas-titulo p {
    font-size: 0.8em;
    font-weight: 600;
  }
  .primeiro {
    text-align: left;
    margin: 0 0 0 5px;
  }
  .ultimo {
    text-align: right;
    margin: 0 5px 0 0;
  }
}
/* ------------------------------------- */

</style>



// WEBPACK FOOTER //
// src/App.vue